import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { IncentiveReport, IncentiveReportResponse, IncentiveSelectedReportResponse } from './incentive.models';
import { map, mapTo } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class IncentiveService {

  private readonly  baseUrl = `${environment.entitlementServiceUrl}/free_report`;
  private readonly freeReportSelectUrl = `${environment.entitlementServiceFreeReportAPIGUrl}`;

  constructor(
    private readonly http: HttpClient
  ) { }

  /**
   * Get free reports for the user
   */
  getFreeReports(): Observable<IncentiveReport[]> {
    return this.http.get<IncentiveReportResponse>(this.baseUrl).pipe(
      map(response => {
        return response.reports
      }),
    );
  }

  /**
   * Choose the actual free report to be entitled
   */
  chooseFreeReport(internal_id: string): Observable<void> {
    const body = { internal_id };
    return this.http.post(this.freeReportSelectUrl, body).pipe(
      mapTo(void 0),
    );
  }

  /**
   * Choose the actual free report to be entitled
   */
  alreadySelectedReport(): Observable<IncentiveSelectedReportResponse> {
    const url = `${this.baseUrl}/already_selected`;

    return this.http.get<IncentiveSelectedReportResponse>(url);
  }
}
